import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../adminTheme.css';
import './adminLayout.css';

export default function AdminLayout() {
  const { username, logout } = useAuth();

  return (
    <div className="cs-admin_shell">
      <aside className="cs-admin_sidebar">
        <div className="cs-admin_brand">
          Meghraj Cinemaz
          <span>Admin</span>
        </div>
        <nav className="cs-admin_nav">
          <NavLink to="/admin/movies" className={({ isActive }) => (isActive ? 'active' : '')}>
            Movies
          </NavLink>
          <NavLink to="/admin/hero" className={({ isActive }) => (isActive ? 'active' : '')}>
            Hero Slides
          </NavLink>
        </nav>
        <div className="cs-admin_sidebar_footer">
          <a href="/" target="_blank" rel="noreferrer">
            View site ↗
          </a>
        </div>
      </aside>

      <div className="cs-admin_main">
        <header className="cs-admin_topbar">
          <span>
            Signed in as <strong>{username}</strong>
          </span>
          <button onClick={logout} className="cs-admin_btn cs-admin_btn-ghost">
            Logout
          </button>
        </header>
        <main className="cs-admin_content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
